export default __webpack_public_path__ + "static/media/LanguageSetting_Icon.beb9e32f.svg";